import { render, staticRenderFns } from "./CustomSidebar.vue?vue&type=template&id=4eebbf97&scoped=true"
import script from "./CustomSidebar.vue?vue&type=script&lang=js"
export * from "./CustomSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomSidebar.vue?vue&type=style&index=0&id=4eebbf97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eebbf97",
  null
  
)

export default component.exports